import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import {
  AbstractAppConfigService,
  APP_CONFIG_SERVICE,
  IHttpBasicResponse,
  JsonApiResponse,
} from "@boxx/core";
import {
  IGBMConversationListApi,
  IGBMConversationMessageListApi,
  IGBMConversationMessageReplyApi,
} from "../models/GBMessages-api.properties";
import { ILeadApi, ILeadsApi } from "../models/Leads-api.properties";
import {
  IReviewApi,
  IReviewLink,
  IReviewsApi,
  IReviewUpsertApi,
} from "../models/Reviews-api.properties";
import { IMessagesRepository } from "./IMessages.repository";
import { NotificationModel } from "../models/Notification.model";

@Injectable()
export class MessagesRepository implements IMessagesRepository {
  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) {}

  // LEADS
  getLeads(pagination: string = ""): Observable<JsonApiResponse<ILeadsApi>> {
    return this.httpClient.get<JsonApiResponse<ILeadsApi>>(
      `${this.appSettings.baseUrl()}/api/json/v1/leads/list?order=DESC`
    );
    //?page=1&per_page=10&order_by=ASC
  }

  setLeadAsRead(id: number): Observable<JsonApiResponse<ILeadApi>> {
    let params = new HttpParams();
    params = params.append("read_status", "READ");

    return this.httpClient.post<JsonApiResponse<ILeadApi>>(
      `${this.getJsonApiBaseUrl()}/leads/update_read_status/${id}`,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      params.toString()
    );
  }

  // REVIEWS
  getReviews(): Observable<IHttpBasicResponse<IReviewsApi>> {
    return this.httpClient.get<IHttpBasicResponse<IReviewsApi>>(
      `${this.getBaseUrl()}/gmb/reviews`
    );
  }

  getReview(reviewId: string) {
    return this.httpClient.get<IHttpBasicResponse<IReviewApi>>(
      `${this.getBaseUrl()}/gmb/review/${reviewId}`
    );
  }

  upsertReply(reviewId: string, comment: string) {
    let params = new HttpParams();
    params = params.append("comment", comment);

    return this.httpClient.post<IHttpBasicResponse<IReviewUpsertApi>>(
      `${this.getBaseUrl()}/gmb/upsertReview/${reviewId}`,
      params.toString()
    );
  }

  deleteReply(reviewId: string) {
    return this.httpClient.delete<IHttpBasicResponse<null>>(
      `${this.getBaseUrl()}/gmb/deleteReview/${reviewId}`
    );
  }

  // NOTIFICATIONS
  getNotifications(): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.getJsonApiBaseUrl()}/notifications/list`
    );
  }

  getReviewLink() {
    return this.httpClient.post<JsonApiResponse<IReviewLink>>(
      `${this.getJsonApiBaseUrl()}/gmb/getUrlReview`,
      null
    );
  }

  setNotificationAsRead(id: number): Observable<JsonApiResponse<ILeadApi>> {
    let params = new HttpParams();
    params = params.append("read_status", "READ");

    return this.httpClient.post<JsonApiResponse<ILeadApi>>(
      `${this.getJsonApiBaseUrl()}/notifications/update/${id}`,
      params.toString()
    );
  }

  deleteNotification(id: number) {
    // console.warn('***************> MockMessagesRepository::deleteNotification()');
    // const responseOk: IHttpBasicResponse<null> = {
    //   data: null,
    //   status: 'success',
    // };

    // return of(responseOk);
    return this.httpClient.delete<IHttpBasicResponse<null>>(
      `${this.getJsonApiBaseUrl()}/notifications/delete/${id}`
    );
  }

  // GBM
  getGBMConversationList(): Observable<
    IHttpBasicResponse<any>
  > {
    return this.httpClient.get<IHttpBasicResponse<any>>(
      `${this.appSettings.baseUrl()}/api/json/v1/messages/list`
    );
  }

  getGBMMessageList(
    conversationId: string
  ): Observable<IHttpBasicResponse<IGBMConversationMessageListApi>> {
    return this.httpClient.post<
      IHttpBasicResponse<IGBMConversationMessageListApi>
    >(
      `${this.appSettings.baseUrl()}/api/json/v1/messages/get/${conversationId}`,
      null
    );
  }

  replyGBMMessage(
    conversationId: string,
    message: string
  ): Observable<IHttpBasicResponse<any>> {
    let params = new HttpParams();
    params = params.append("text", message);
    return this.httpClient.post<
      IHttpBasicResponse<any>
    >(
      `${this.appSettings.baseUrl()}/api/json/v1/messages/send/${conversationId}`,
      params.toString()
    );
  }

  getBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/${this.appSettings.instance()}/v1`;
  }
  getJsonApiBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/json/v1`;
  }
}
